import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import _ from 'lodash';
import { DeployableManagementService } from '../DeployableManagementService';
const defaultValue = {
    HTML: '<html>\n\n<head>\n    <title></title>\n    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n    <meta name="viewport" content="width=device-width, initial-scale=1" />\n    <style type="text/css">\n    </style>\n</head>\n\n<body>\n    Hello World\n</body>\n\n</html>\n',
    MJML: '<mjml>\n    <mj-body>\n        <mj-section>\n            <mj-column>\n                <mj-image width="100px" src="https://mjml.io/assets/img/logo-small.png"></mj-image>\n                <mj-divider border-color="#F45E43"></mj-divider>\n                <mj-text font-size="20px" color="#F45E43" font-family="helvetica">Hello World</mj-text>\n            </mj-column>\n        </mj-section>\n    </mj-body>\n</mjml>\n',
};
let EmailTemplateManagementService = class EmailTemplateManagementService extends DeployableManagementService {
    constructor(emailTemplateManagementApi, promptManagementApi, i18n) {
        super();
        this.emailTemplateManagementApi = emailTemplateManagementApi;
        this.promptManagementApi = promptManagementApi;
        this.i18n = i18n;
        this.image2Code = this.emailTemplateManagementApi.image2Code;
        this.list = this.emailTemplateManagementApi.listPagination;
        this.getDetail = this.emailTemplateManagementApi.getTemplate;
        this.deleteTemplate = this.emailTemplateManagementApi.deleteTemplate;
        this.updateContentTemplate = this.emailTemplateManagementApi.updateContentTemplate;
        this.updateContentMock = this.emailTemplateManagementApi.updateContentMock;
        this.updateContentI18n = this.emailTemplateManagementApi.updateContentI18n;
        this.sendMail = this.emailTemplateManagementApi.sendMail;
        this.publishLocal = this.emailTemplateManagementApi.publishLocalTemplate;
        this.publishUpdate = this.emailTemplateManagementApi.publishUpdateTemplate;
        this.keyGen = this.promptManagementApi.keyGen;
        this.preview = this.emailTemplateManagementApi.preview;
    }
    updateBasic(data) {
        const params = _.pick(data, ['id', 'template_key', 'product', 'feature', 'name']);
        return this.emailTemplateManagementApi.updateBasic(params);
    }
    addTemplate(data) {
        const addParams = {
            ...data,
            content: data?.content || this.getTemplateDefault(data.format),
            i18n: data?.i18n || {
                CN: {},
                EN: {},
                JP: {},
                TW: {},
            },
        };
        return this.emailTemplateManagementApi.addTemplate(addParams);
    }
    getTemplateDefault(format) {
        return defaultValue[format];
    }
    getFormatOptions() {
        return [
            { text: 'HTML', value: 'HTML' },
            { text: 'MJML', value: 'MJML' }
        ];
    }
};
EmailTemplateManagementService = __decorate([
    injectable(),
    __param(0, inject(Symbols.EmailTemplateManagementApi)),
    __param(1, inject(Symbols.PromptManagementApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], EmailTemplateManagementService);
export { EmailTemplateManagementService };
